var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoGoogleAnalytics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27747 55.5549C9.74443 55.5549 12.5549 52.842 12.5549 49.4954C12.5549 46.1488 9.74443 43.4359 6.27747 43.4359C2.81052 43.4359 0 46.1488 0 49.4954C0 52.842 2.81052 55.5549 6.27747 55.5549Z",
    fill: "#E37400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.381 56C20.7737 56 17.8506 53.1785 17.8506 49.6964V28.1938C17.8506 24.7118 20.7737 21.8903 24.381 21.8903C27.9883 21.8903 30.9114 24.7118 30.9114 28.1938V49.6964C30.9114 53.1785 27.9883 56 24.381 56Z",
    fill: "#E37400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4696 56C39.8623 56 36.9393 53.1785 36.9393 49.6964V6.30359C36.9467 2.82154 39.8698 0 43.4696 0C47.077 0 50 2.82154 50 6.30359V49.6964C50 53.1785 47.077 56 43.4696 56Z",
    fill: "#F9AB00"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoGoogleAnalytics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_google_analytics.c132997c6c0dd8c4ffb704449b499fe7.svg";